import { Ionicons } from '@expo/vector-icons';
import React from 'react';
import { Pressable, StyleSheet, View } from 'react-native';

import { Text } from '@/components/ui';

/**
 * What a reset does to the ACCOUNTS, spelled out. A re-import fills only empty
 * fields, so it never undoes a hand-corrected address — but a reset deletes the
 * accounts first, and the file's addresses come back with them (#635).
 */
export const RESET_ACCOUNTS_WARNING = 'This deletes every account in the association, including hand-corrected '
	+ 'addresses — they will be re-imported from the file.';

interface Props {
	checked: boolean;
	onToggle: () => void;
}

/** The QuickBooks rebuild's destructive "Reset" checkbox. */
export const QbResetToggle = ({ checked, onToggle }: Props) => (
	<Pressable style={styles.row} onPress={onToggle} testID="qb-reset-toggle">
		<Ionicons name={checked ? 'checkbox' : 'square-outline'} size={20} color={checked ? '#b71c1c' : '#90a4ae'} />
		<View style={styles.copy}>
			<Text style={styles.text}>
				Reset: back up, then wipe ALL accounting data for this association before rebuilding (super-admin)
			</Text>
			<Text style={styles.warning}>{RESET_ACCOUNTS_WARNING}</Text>
		</View>
	</Pressable>
);

const styles = StyleSheet.create({
	row: { flexDirection: 'row', alignItems: 'center', gap: 8 },
	// minWidth 0: a flex child otherwise refuses to shrink below its text and overflows the row.
	copy: { flex: 1, minWidth: 0, gap: 2 },
	text: { fontSize: 12, color: '#546e7a' },
	warning: { fontSize: 12, color: '#b71c1c' },
});
